import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initImageSlider() {
  Alpine.data(
    'imageSlider',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        const swiperEl = document.querySelector('.swiper-slider-images');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          spaceBetween: 30,
          slidesPerView: 1,
          autoHeight: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: '.swiper-slider-images__buttons .swiper-button-next',
            prevEl: '.swiper-slider-images__buttons .swiper-button-prev',
          },
        });
      },
    }),
  );
}
